import { render, staticRenderFns } from "./union-nav-bar.vue?vue&type=template&id=7256202a&"
import script from "./union-nav-bar.vue?vue&type=script&lang=js&"
export * from "./union-nav-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7256202a')) {
      api.createRecord('7256202a', component.options)
    } else {
      api.reload('7256202a', component.options)
    }
    module.hot.accept("./union-nav-bar.vue?vue&type=template&id=7256202a&", function () {
      api.rerender('7256202a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/union-nav-bar.vue"
export default component.exports